import { createFileRoute } from '@tanstack/react-router';
import { redirectIfGameLoaded } from 'engine/api';

// @ts-expect-error importing this gives error but it works
import { About } from '@platformComponents/about';

export const Route = createFileRoute('/about')({
	component: RouteComponent,
	beforeLoad: redirectIfGameLoaded,
});

function RouteComponent() {
	return <About />;
}
